import './product-loader.scss'
import './product-preview.component.scss'
const loaderElement = document.createElement('DIV')
loaderElement.classList.add('product-loader')
loaderElement.innerHTML = '<div></div><div></div><div></div><div></div>'

const loader = (image, isActive) => {
  const current = image.querySelector('.product-loader')
  if (isActive && !current) {
    image.append(loaderElement.cloneNode(true))
  } else if (!isActive && current) {
    current.remove()
  }
}

const SELECTORS = {
  container: '.product-preview',
  imageContainer: '.product-preview__image',
  imageItem: '.product-preview-colors__item[data-image-src]',
  imageItemActive: '.product-preview-colors__item.is-active',
  fav: '.product-favorite',
  meta: '.product-preview__meta span:last-child',
  price: '[data-money]',
  retail: '[data-retail-price]',
  _active: 'is-active'
}

const productClickHandler = (event) => {
  const { target } = event
  const colorItem = target.closest(SELECTORS.imageItem)
  if (colorItem) {
    const container = colorItem.closest(SELECTORS.container)
    const imageContainer = container.querySelector(SELECTORS.imageContainer)
    const metaItem = container.querySelector(SELECTORS.meta)
    const priceItem = container.querySelector(SELECTORS.price)
    const retailItem = container.querySelector(SELECTORS.retail)
    const image = imageContainer.querySelectorAll('img')
    const { id, varid, imageSrc, imageSecondSrc, badge, price, retail } = colorItem.dataset
    const favItem = container.querySelector(SELECTORS.fav)
    image[0].addEventListener(
      'load',
      () => {
        loader(imageContainer, false)
      },
      { once: true }
    )
    if (image[0].src !== imageSrc) {
      image[0].src = imageSrc
      if (image[1] && image[1].src !== imageSecondSrc) {
        image[1].src = imageSecondSrc
      }
      container
        .querySelectorAll(SELECTORS.imageItemActive)
        .forEach((colorCorrentItem) =>
          colorCorrentItem.classList.remove(SELECTORS._active)
        )
      colorItem.classList.add(SELECTORS._active)
      favItem.dataset.id = id
      favItem.dataset.varid = varid
      metaItem.innerText = badge
      priceItem.innerText = price
      if(price != retail && retail != ''){
        retailItem.innerText = retail
        retailItem.classList.remove('hidden')
      }
      else {
        retailItem.innerText = ''
        retailItem.classList.add('hidden')
      }
      loader(imageContainer, true)
      container.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }
}
document.addEventListener('click', productClickHandler)
